
import { PropType, defineComponent } from "vue";
import "codemirror/mode/sql/sql.js";
import "codemirror/lib/codemirror.css";

export default defineComponent({
  name: "sdk-sql-editor",
  components: {
    codemirror: () => import("vue-codemirror").then((module) => module.codemirror),
  },
  props: {
    sql: {
      type: String,
      required: true,
    },
    options: {
      type: Object as PropType<any>,
      required: true,
    },
    inputAction: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      randomId: Math.ceil(Math.random() * 666),
    };
  },
});
